/*
 * @Author: Teemo Ding
 * @Date: 2021-05-26 15:37:43
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-06-23 15:31:10
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelCollection/SalesChannelCollectionEdit.tsx
 */
import { getI18nFromGeneral } from '@/src/tools/tools';
import React, { Fragment, ReactNode, useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';

import Warning from '@/src/components/Antd/Modal/WarningModal';
import NoPermission from '@/src/components/NoPermission';
import { message } from 'antd';
import { Modal, Skeleton } from 'src/components/Antd';
import RouteBlock from 'src/constrains/RouterBlock/RouterBlock';
import Layout from 'src/layout/EditorPageLayout/EditorCollapsePageLayout';
// import Layout from 'src/layout/EditorPageLayout/EditorPageLayout';

import ErrorModal from '@/src/components/ErrorModal/ErrorModal';
import ErrorModalTitle from '@/src/components/ErrorModal/ErrorModalTitle';
import MultiLangDropDown from '@/src/constrains/SalesChannelMultiLanguageSelect/MultiLangDropDown';
import TopLeft from '@/src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import TopRight from '@/src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';
import SalesChannelHOC from 'src/constrains/SalesChannelHOC/SalesChannelHOC';

import {
  addCollection,
  checkCollectionUnique,
  deleteCollection,
  getCollectionList,
} from '@/src/request/salesChannel/collection';
import { getParameter } from '@/src/tools/helper';
import { ChannelType } from '@/src/types/common/SalesChannel';
import {
  // // EnumAction,
  EnumMultiLanguageType,
} from 'src/constrains/SalesChannelMultiLanguageSelect';
import { _SelectHOC } from '../SalesChannelLegal/Components/EditorHOC';
import CollectionInfo from './Components/CollectionInfo';
import FeaturedImage from './Components/FeaturedImage/Image';
import Products from './Components/Products';
import SEOSetting from './Components/SEOSetting';

import { currentSelectedLanguage } from 'src/constrains/SalesChannelMultiLanguageSelect/slice';
import {
  fetchCollectionDetail,
  onCollapseChange,
  onLanguageChange,
  setFeaturedImage,
  setName,
  setNameError,
  setProducts,
  setSEOSetting,
} from './slice/edit';

import { NEW } from 'src/tools/constant';
import { IParams } from './type';

import { useI18n } from 'src/hooks/useRouterChange';
import {
  isUserValid,
  salesChannelResourceNameGenerator,
} from 'src/tools/getUserInfo';
import { i18nGet } from 'src/tools/tools';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';

const permissions = (saleChannelUuid) => {
  const canViewDetails = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        uuid: saleChannelUuid,
        category: EnumCategory.SalesChannelProductCollection,
        subCategory: EnumSubCategory.ChannelProductCollection,
        operation: EnumOperation.view_collection_details_page,
      }),
    ],
  });
  const canCreate = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        uuid: saleChannelUuid,
        category: EnumCategory.SalesChannelProductCollection,
        subCategory: EnumSubCategory.ChannelProductCollection,
        operation: EnumOperation.add_edit_product_collection,
      }),
    ],
  });
  const canDelete = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        uuid: saleChannelUuid,
        category: EnumCategory.SalesChannelProductCollection,
        subCategory: EnumSubCategory.ChannelProductCollection,
        operation: EnumOperation.delete_product_collection,
      }),
    ],
  });
  return { canViewDetails, canCreate, canDelete };
};

const SalesChannelCollectionEdit = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const params: IParams = useParams();
  const { isPrimary } = props;
  const history = useHistory();
  const type = getParameter('type');
  const { uuid: saleChannelUuid, collectionsUuid } = params;
  const currentLanguage = useSelector(currentSelectedLanguage());
  const state = useSelector((state: any) => state.salesChannelCollectionEdit);
  const [discardModal, setDiscardModal] = React.useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState<string | ReactNode>('');
  const [modalContent, setModalContent] = useState<string | ReactNode>('');
  const [collectionList, setCollectionList] = useState([]);
  const [salesChannelName, setSalesChannelName] = useState('');
  const [salesChannelType, setSalesChannelType] = useState('');
  const [loading, setLoading] = useState(true);

  const userPermissions = permissions(saleChannelUuid);

  const {
    seoSetting,
    featuredImage,
    hasModified,
    products,
    loaded,
    collectionName,
    collectionNameError,
    salesChannelProductUuids = [],
  } = state;
  const pageTitle =
    collectionsUuid == NEW
      ? getI18n('productCollection.index.addNewCollection')
      : getI18n('productCollection.index.editCollection');
  const _d = useDispatch();
  const breadcrumbData = [
    {
      url: '/',
      name: getI18n('general.sider.home'),
    },
    {
      url: '',
      name: getI18n('general.sider.salesChannel'),
    },
    {
      url: '',
      name: salesChannelName,
    },
    {
      url: '',
      name: getI18n('productCollection.index.productCollection'),
    },
    {
      url: '',
      name: pageTitle,
    },
  ];

  useEffect(() => {
    getCollectionList(
      { salesChannelUuid: saleChannelUuid },
      { salesChannelMultiLanguageRequired: true },
    ).then((data) => {
      setCollectionList(data.summaryList);
      setSalesChannelName(data.salesChannelName);
      setSalesChannelType(data.salesChannelType);
      const nameList = data.summaryList.map((item) => item.collectionName);
      if (collectionsUuid !== NEW) {
        if (type == 'Duplicate') {
          _d(onLanguageChange(true));
        }
        _d(setNameError(''));
        _d(
          fetchCollectionDetail({
            uuid: collectionsUuid,
            list: nameList,
            params: {
              salesChannelMultiLanguageRequired: true,
            },
          }),
        );
      } else {
        _d(
          setName(
            `${getI18n('general.collections')} ${data.summaryList.length + 1}`,
          ),
        );
      }
      setTimeout(() => {
        setLoading(false);
      }, 500);
    });
    return () => {
      //  组件销毁，清空redux里的数据
      _d(
        setFeaturedImage({
          uuid: '',
          fileName: '',
          url: '',
          size: '',
          width: '',
          height: '',
        }),
      );
      _d(setProducts([]));
      _d(
        setSEOSetting({
          title: '',
          description: '',
          urlSlug: '',
          slugValid: true,
        }),
      );
    };
  }, [currentLanguage]);

  const checkNameUnique = () => {
    if (collectionName) {
      checkCollectionUnique({
        salesChannelUuid: saleChannelUuid,
        uuid: type == 'Duplicate' ? '' : collectionsUuid,
        queryContent: collectionName,
      }).then((data) => {
        _d(setNameError(data));
      });
    }
  };

  const handleCancel = () => {
    setShowModal(false);
  };

  const onSubmit = async (params?) => {
    const { hideMsg } = params || {};
    if (
      isPrimary &&
      salesChannelType !== ChannelType.MiniProgram &&
      !seoSetting.slugValid
    ) {
      _d(onCollapseChange({ id: 'SEOSetting', status: true }));
      return false;
    }
    checkNameUnique();
    const response = await addCollection(
      {
        uuid:
          collectionsUuid === NEW || type == 'Duplicate' ? '' : collectionsUuid,
        collectionName: collectionName,
        salesChannelUuid: saleChannelUuid,
        ...(salesChannelType !== ChannelType.MiniProgram
          ? { seoSetting: seoSetting }
          : {}),
        imageUuid: (featuredImage || {}).uuid,
        salesChannelProductUuids: salesChannelProductUuids,
      },
      { salesChannelMultiLanguageRequired: true },
    );
    _d(onLanguageChange(false));
    message.success(
      getI18nFromGeneral('general.status.changessavesuccessfully'),
    );
    history.push(`/salesChannel/collections/list/${saleChannelUuid}`);
    return { response, hideMsg };
  };

  const handleSlugOnChange = ({ slug, valid }) => {
    _d(setSEOSetting({ urlSlug: slug, slugValid: valid }));
  };

  const Child = React.useMemo(() => {
    if (userPermissions.canViewDetails || collectionsUuid == NEW) {
      return [
        {
          element: CollectionInfo,
          id: 'CollectionInfo',
          p: {
            collectionNameOnChange: (value) => {
              _d(setName(value));
            },
            type: type,
            collectionName: collectionName,
            onBlur: () => checkNameUnique(),
            error: collectionNameError,
            disabled: !isPrimary || !userPermissions.canCreate,
          },
        },
        ...(salesChannelType !== ChannelType.MiniProgram
          ? [
              {
                element: SEOSetting,
                id: 'SEOSetting',
                p: {
                  title: (seoSetting || {}).title,
                  uuid: collectionsUuid,
                  type: type,
                  handleOnTitleChange: (value) =>
                    _d(setSEOSetting({ title: value })),
                  description: (seoSetting || {}).description,
                  handleOnDescriptionChange: (value) =>
                    _d(setSEOSetting({ description: value })),

                  urlSlug: (seoSetting || {}).urlSlug,
                  slugValid: (seoSetting || {}).slugValid,
                  saleChannelUuid: saleChannelUuid,
                  handleSlugOnChange: handleSlugOnChange,
                  isPrimary: isPrimary,
                  disabled: !userPermissions.canCreate,
                },
              },
            ]
          : []),
        {
          element: FeaturedImage,
          id: 'FeaturedImage',
          p: {
            featuredImage: featuredImage,
            disabled: !userPermissions.canCreate,
            onChange: (image) => {
              _d(setFeaturedImage(image));
            },
          },
        },
        {
          element: Products,
          id: 'Products',
          p: {
            products: products,
            onChange: (data) => {
              _d(setProducts(data));
            },
            salesChannelUuid: saleChannelUuid,
            salesChannelProductUuids: salesChannelProductUuids,
            collectionList: collectionList,
            setModalTitle: setModalTitle,
            setModalContent: setModalContent,
            setShowModal: setShowModal,
            isPrimary: isPrimary,
            disabled: !userPermissions.canCreate,
          },
        },
      ];
    } else {
      return [{ element: NoPermission }];
    }
  }, [
    loaded,
    products,
    featuredImage,
    collectionName,
    seoSetting,
    collectionNameError,
    isPrimary,
  ]);

  const goBackToList = () => {
    history.push({
      pathname: `/salesChannel/collections/list/${saleChannelUuid}`,
    });
  };
  const handleDelete = () => {
    deleteCollection(collectionsUuid).then(() => {
      message.success(getI18n('general.deletedsuccessfully'));
      goBackToList();
    });
  };
  const onDelete = () => {
    setModalContent(
      <ErrorModal
        setModal={setShowModal}
        onSubmit={handleDelete}
        okText={getI18n('general.delete')}
        errorText={getI18n(
          'productCollection.index.deletedcollectionerrortext',
        )}
      />,
    );
    setShowModal(true);
    setModalTitle(
      <ErrorModalTitle>
        {getI18n('productCollection.index.deletecollection')}
      </ErrorModalTitle>,
    );
  };

  const topLeft = (
    <TopLeft goBack={goBackToList} breadcrumbData={breadcrumbData} />
  );

  const topRight = (
    <TopRight
      {...(collectionsUuid === NEW
        ? {}
        : {
            onDelete: userPermissions.canDelete && onDelete,
            displayDuplicateGroup: true,
          })}
      extraLeft={
        <div style={{ marginRight: 8 }}>
          <MultiLangDropDown
            hasModified={hasModified}
            salesChannelUuidKey='uuid'
          />
        </div>
      }
      onDiscard={goBackToList}
      onSubmit={userPermissions.canCreate && onSubmit}
      onSaveDisable={!hasModified}
    />
  );
  const toCollectionList = () => {
    history.push(`/salesChannel/collections/${saleChannelUuid}}`);
  };

  return (
    <Fragment>
      <RouteBlock
        onConfirm={(f) => f()}
        okText={getI18n('general.commonHeader.leave_text')}
        active={hasModified && !discardModal}
        title={getI18nFromGeneral('general.commonHeader.leave_header')}
        content={getI18nFromGeneral('general.commonHeader.leave_content')}
      />
      <Warning
        header={getI18nFromGeneral('general.commonHeader.discard_header')}
        onCancel={() => {
          setDiscardModal(false);
        }}
        cancelText={getI18n('general.commonHeader.discard_cancel')}
        onOk={toCollectionList}
        okText={getI18nFromGeneral('general.commonHeader.discard_text')}
        visible={discardModal}
        title={getI18nFromGeneral('general.commonHeader.discard_header')}>
        <span>{getI18n('general.commonHeader.discard_content')}</span>
      </Warning>
      <Skeleton loading={loading} active>
        <Layout elements={Child} topLeft={topLeft} topRight={topRight} />
      </Skeleton>
      <Modal
        width={600}
        visible={showModal}
        title={modalTitle}
        onCancel={handleCancel}
        maskClosable={false}
        cancelText={getI18n('general.cancel')}>
        {modalContent}
      </Modal>
    </Fragment>
  );
};
export default SalesChannelHOC(_SelectHOC(SalesChannelCollectionEdit), {
  type: EnumMultiLanguageType.SalesChannelCollection,
});
